export const SEND_POOL_REQUEST_FAILURE = 'SEND_POOL_REQUEST_FAILURE';

export const sendPoolRequestFailure = error => ({
    type: SEND_POOL_REQUEST_FAILURE,
    payload: error,
    error: true,
});
